var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "eco-part small pt-0" },
    [
      _c(
        "p",
        { staticClass: "mb-0 p-0 d-inline" },
        [
          _c("span", [_vm._v(_vm._s(_vm.ecoPartLabel))]),
          _vm._v(" "),
          _c("ob1-liens", {
            staticClass: "p-0",
            attrs: {
              type: "button",
              "is-button": true,
              "modal-id": _vm.ecoPartModalId,
              text: _vm.ecoPartLinkLabelText,
            },
          }),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "\n            " +
                _vm._s(_vm.privateCopyingLabelText) +
                "\n            "
            ),
            _c(
              "a",
              {
                staticClass: "ob1-link pb-0",
                attrs: { href: _vm.privateCopyingLink, target: _vm.target },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.privateCopyingLinkText) +
                    "\n            "
                ),
              ]
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ob1-popin-modal2",
        { attrs: { id: _vm.ecoPartModalId, "aria-labelledby": _vm.id } },
        [
          _c("h4", { attrs: { id: _vm.id } }, [
            _vm._v(
              "\n            " + _vm._s(_vm.ecoPartModalTitle) + "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("p", { domProps: { innerHTML: _vm._s(_vm.ecoPartModalText) } }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }